const LOCAL_BACKEND_URL = "http://127.0.0.1:8000/api";
const PRODUCTION_BACKEND_URL = "https://uttarakhand-travel-app-123.onrender.com/api";
const DEFAULT_GOOGLE_CLIENT_ID =
  "239043263832-pm1c1ooqnkuhlb2n8gqvcuj0518ltm93.apps.googleusercontent.com";

const normalizeBaseUrl = (value) => (value ? value.replace(/\/+$/, "") : "");

const isBrowser = typeof window !== "undefined";
const hostname = isBrowser ? window.location.hostname : "";
const isLocalHost = hostname === "localhost" || hostname === "127.0.0.1";
const configuredBackendUrl = normalizeBaseUrl(process.env.REACT_APP_BACKEND_URL);

const API_BASE_URL =
  configuredBackendUrl || (isBrowser && !isLocalHost ? PRODUCTION_BACKEND_URL : LOCAL_BACKEND_URL);

export const GOOGLE_CLIENT_ID =
  process.env.REACT_APP_GOOGLE_CLIENT_ID || DEFAULT_GOOGLE_CLIENT_ID;

export default API_BASE_URL;
